import { render, staticRenderFns } from "./PDPA.vue?vue&type=template&id=22a068d0&scoped=true&"
import script from "./PDPA.vue?vue&type=script&lang=js&"
export * from "./PDPA.vue?vue&type=script&lang=js&"
import style0 from "./PDPA.vue?vue&type=style&index=0&id=22a068d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a068d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
